import useSWR from 'swr'
import { useToken } from "@app/hooks";
import API from "../../../utils/api";



const M_KEY = '/system/setting'

const fetchKey = ( pubkey) =>
  `${M_KEY}?${pubkey ? 'pubkey=' + pubkey : ''}`;

export function useSystemSetting(pubkey) {
  const {data: token} = useToken();

  const KEY = fetchKey(pubkey);

  const fetcher = () => fetchAPI(KEY, token);
  const {data, mutate} = useSWR(token ? `${KEY}` : null, fetcher,
    {
      revalidateOnFocus: true,
      // refreshInterval: 60000,
      // revalidateOnReconnect: true,
    });

  return {SystemSetting: data?.list, SystemSettingMutate: mutate};
}

async function fetchAPI(KEY: string, token: any) {
  try {
    const response = await API.get(`${KEY}`, token + '', {});

    return {list: response?.result};
  } catch (error) {
    console.error('Failed to fetch System Setting ===> ', error);
    return {list: []};
  }
}